
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smartphone/[slug]",
      function () {
        return require("private-next-pages/smartphone/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smartphone/[slug]"])
      });
    }
  